/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as ShellIndexRouteImport } from './routes/_shell.index'
import { Route as ShellAgentsRouteImport } from './routes/_shell.agents'
import { Route as ShellCategoriesAreasRouteImport } from './routes/_shell.categories-areas'
import { Route as ShellContentRouteImport } from './routes/_shell.content'
import { Route as ShellJobsRouteImport } from './routes/_shell.jobs'
import { Route as ShellReviewsRouteImport } from './routes/_shell.reviews'
import { Route as ShellSettingsRouteImport } from './routes/_shell.settings'
import { Route as ShellMembersIndexRouteImport } from './routes/_shell.members.index'
import { Route as ShellMembersMemberNumberRouteImport } from './routes/_shell.members.$memberNumber'
import { Route as ShellProvidersIndexRouteImport } from './routes/_shell.providers.index'
import { Route as ShellProvidersProviderIdRouteImport } from './routes/_shell.providers.$providerId'

const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellIndexRoute = ShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAgentsRoute = ShellAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCategoriesAreasRoute = ShellCategoriesAreasRouteImport.update({
  id: '/categories-areas',
  path: '/categories-areas',
  getParentRoute: () => ShellRoute,
} as any)
const ShellContentRoute = ShellContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => ShellRoute,
} as any)
const ShellJobsRoute = ShellJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => ShellRoute,
} as any)
const ShellReviewsRoute = ShellReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSettingsRoute = ShellSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMembersIndexRoute = ShellMembersIndexRouteImport.update({
  id: '/members/',
  path: '/members/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMembersMemberNumberRoute =
  ShellMembersMemberNumberRouteImport.update({
    id: '/members/$memberNumber',
    path: '/members/$memberNumber',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellProvidersIndexRoute = ShellProvidersIndexRouteImport.update({
  id: '/providers/',
  path: '/providers/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellProvidersProviderIdRoute =
  ShellProvidersProviderIdRouteImport.update({
    id: '/providers/$providerId',
    path: '/providers/$providerId',
    getParentRoute: () => ShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ShellIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/agents': typeof ShellAgentsRoute
  '/categories-areas': typeof ShellCategoriesAreasRoute
  '/content': typeof ShellContentRoute
  '/jobs': typeof ShellJobsRoute
  '/reviews': typeof ShellReviewsRoute
  '/settings': typeof ShellSettingsRoute
  '/members/$memberNumber': typeof ShellMembersMemberNumberRoute
  '/providers/$providerId': typeof ShellProvidersProviderIdRoute
  '/members/': typeof ShellMembersIndexRoute
  '/providers/': typeof ShellProvidersIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/agents': typeof ShellAgentsRoute
  '/categories-areas': typeof ShellCategoriesAreasRoute
  '/content': typeof ShellContentRoute
  '/jobs': typeof ShellJobsRoute
  '/reviews': typeof ShellReviewsRoute
  '/settings': typeof ShellSettingsRoute
  '/': typeof ShellIndexRoute
  '/members/$memberNumber': typeof ShellMembersMemberNumberRoute
  '/providers/$providerId': typeof ShellProvidersProviderIdRoute
  '/members': typeof ShellMembersIndexRoute
  '/providers': typeof ShellProvidersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_shell': typeof ShellRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/_shell/agents': typeof ShellAgentsRoute
  '/_shell/categories-areas': typeof ShellCategoriesAreasRoute
  '/_shell/content': typeof ShellContentRoute
  '/_shell/jobs': typeof ShellJobsRoute
  '/_shell/reviews': typeof ShellReviewsRoute
  '/_shell/settings': typeof ShellSettingsRoute
  '/_shell/': typeof ShellIndexRoute
  '/_shell/members/$memberNumber': typeof ShellMembersMemberNumberRoute
  '/_shell/providers/$providerId': typeof ShellProvidersProviderIdRoute
  '/_shell/members/': typeof ShellMembersIndexRoute
  '/_shell/providers/': typeof ShellProvidersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/no-access'
    | '/reset-password'
    | '/set-password'
    | '/agents'
    | '/categories-areas'
    | '/content'
    | '/jobs'
    | '/reviews'
    | '/settings'
    | '/members/$memberNumber'
    | '/providers/$providerId'
    | '/members/'
    | '/providers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/no-access'
    | '/reset-password'
    | '/set-password'
    | '/agents'
    | '/categories-areas'
    | '/content'
    | '/jobs'
    | '/reviews'
    | '/settings'
    | '/'
    | '/members/$memberNumber'
    | '/providers/$providerId'
    | '/members'
    | '/providers'
  id:
    | '__root__'
    | '/_shell'
    | '/forgot-password'
    | '/login'
    | '/no-access'
    | '/reset-password'
    | '/set-password'
    | '/_shell/agents'
    | '/_shell/categories-areas'
    | '/_shell/content'
    | '/_shell/jobs'
    | '/_shell/reviews'
    | '/_shell/settings'
    | '/_shell/'
    | '/_shell/members/$memberNumber'
    | '/_shell/providers/$providerId'
    | '/_shell/members/'
    | '/_shell/providers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ShellRoute: typeof ShellRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  NoAccessRoute: typeof NoAccessRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetPasswordRoute: typeof SetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/': {
      id: '/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ShellIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/agents': {
      id: '/_shell/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof ShellAgentsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/categories-areas': {
      id: '/_shell/categories-areas'
      path: '/categories-areas'
      fullPath: '/categories-areas'
      preLoaderRoute: typeof ShellCategoriesAreasRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/content': {
      id: '/_shell/content'
      path: '/content'
      fullPath: '/content'
      preLoaderRoute: typeof ShellContentRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/jobs': {
      id: '/_shell/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof ShellJobsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/reviews': {
      id: '/_shell/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof ShellReviewsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/settings': {
      id: '/_shell/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof ShellSettingsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/members/': {
      id: '/_shell/members/'
      path: '/members'
      fullPath: '/members/'
      preLoaderRoute: typeof ShellMembersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/members/$memberNumber': {
      id: '/_shell/members/$memberNumber'
      path: '/members/$memberNumber'
      fullPath: '/members/$memberNumber'
      preLoaderRoute: typeof ShellMembersMemberNumberRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/providers/': {
      id: '/_shell/providers/'
      path: '/providers'
      fullPath: '/providers/'
      preLoaderRoute: typeof ShellProvidersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/providers/$providerId': {
      id: '/_shell/providers/$providerId'
      path: '/providers/$providerId'
      fullPath: '/providers/$providerId'
      preLoaderRoute: typeof ShellProvidersProviderIdRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface ShellRouteChildren {
  ShellAgentsRoute: typeof ShellAgentsRoute
  ShellCategoriesAreasRoute: typeof ShellCategoriesAreasRoute
  ShellContentRoute: typeof ShellContentRoute
  ShellJobsRoute: typeof ShellJobsRoute
  ShellReviewsRoute: typeof ShellReviewsRoute
  ShellSettingsRoute: typeof ShellSettingsRoute
  ShellIndexRoute: typeof ShellIndexRoute
  ShellMembersMemberNumberRoute: typeof ShellMembersMemberNumberRoute
  ShellProvidersProviderIdRoute: typeof ShellProvidersProviderIdRoute
  ShellMembersIndexRoute: typeof ShellMembersIndexRoute
  ShellProvidersIndexRoute: typeof ShellProvidersIndexRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellAgentsRoute: ShellAgentsRoute,
  ShellCategoriesAreasRoute: ShellCategoriesAreasRoute,
  ShellContentRoute: ShellContentRoute,
  ShellJobsRoute: ShellJobsRoute,
  ShellReviewsRoute: ShellReviewsRoute,
  ShellSettingsRoute: ShellSettingsRoute,
  ShellIndexRoute: ShellIndexRoute,
  ShellMembersMemberNumberRoute: ShellMembersMemberNumberRoute,
  ShellProvidersProviderIdRoute: ShellProvidersProviderIdRoute,
  ShellMembersIndexRoute: ShellMembersIndexRoute,
  ShellProvidersIndexRoute: ShellProvidersIndexRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ShellRoute: ShellRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  NoAccessRoute: NoAccessRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetPasswordRoute: SetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
